import { firebaseOptions } from "../../firebaseConfig";

/**
 * The old login persisted its Firebase session through getAuth()'s default (IndexedDB, localStorage).
 * Sessions now live in the tab only, so the stale entry of an earlier visit is removed on start: on a
 * shared waiting-room device it would keep a refresh token around indefinitely. Main app only.
 */
export const purgeLegacyAuthSession = () => {
  const key = `firebase:authUser:${firebaseOptions.apiKey}:[DEFAULT]`;
  try {
    localStorage.removeItem(key);
  } catch {
    // storage blocked
  }
  try {
    const request = indexedDB.open("firebaseLocalStorageDb");
    // Never create the database when it does not exist.
    request.onupgradeneeded = () => request.transaction?.abort();
    request.onsuccess = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains("firebaseLocalStorage")) return database.close();
      const transaction = database.transaction("firebaseLocalStorage", "readwrite");
      transaction.objectStore("firebaseLocalStorage").delete(key);
      transaction.oncomplete = () => database.close();
    };
  } catch {
    // IndexedDB unavailable
  }
};
